<template>
  <div class="classroom wrap">
    <div class="createRoom">
      <div class="c-title">{{username}} <span>欢迎您</span></div>
      <div class="c-body">
        <span class=" c-label">教室ID</span>
        <div class="roomId">
          {{roomInfo.roomId}}
        </div>
        <span class="c-label">请选择授课语言</span>
        <div class="chooseLan lan" @click.stop.prevent="dropDown=!dropDown">
          {{currentLang}}
          <ul class="drop-down" v-show="!dropDown">
            <li v-for="(lang, index) in langData" @click="selectLang(index, lang)">
              <a class="lan" href="javascript:;">{{lang.name}}</a>
            </li>
          </ul>                 
        </div>        
        <div style="margin-top:40px">
          <button class="c-btn" @click="joinRoom()" >上课</button>
          <button class="p-btn rtSignUp" @click="prepareLession()">备课</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { ajaxAPI } from '@/utils/ajaxUtil'
import { HYBIRD_URL } from '@/config/url_config'
import CourseList from '@/components/CourseList'
export default {
  components: {
    CourseList
  },
  data () {
    return {
      accessToken: window.localStorage.getItem('accessToken'),
      roomInfo: {},
      currentLang: '',
      language: '',
      username: '',
      toggle: false,
      langData: [
        {name: 'JAVA', languageId: 10},
        {name: 'HTML/CSS/JS', languageId: 35},
        {name: 'Python', languageId: 4},
        {name: 'C', languageId: 11},
        {name: 'PHP', languageId: 29}
      ],
      dropDown: true
    }
  },
  created () {
  },
  mounted () {
    let userInfo = JSON.parse(window.localStorage.getItem('userInfo'))
    this.username = userInfo.mobile.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2') || userInfo.userName
    console.log(userInfo)
    ajaxAPI('GET', `${HYBIRD_URL}/programming/room/user/api?access_token=${this.accessToken}`).then(data => {
      console.log(data)
      this.roomInfo = data.data.data
      this.language = data.data.data.languageId
      console.log(this.langData[0].name)
      if (data.data.data.languageId === '10') {
        this.currentLang = this.langData[0].name
      } else if (data.data.data.languageId === '35') {
        this.currentLang = this.langData[1].name
      } else if (data.data.data.languageId === '4') {
        this.currentLang = this.langData[2].name
      } else if (data.data.data.languageId === '11') {
        this.currentLang = this.langData[3].name
      } else if (data.data.data.languageId === '29') {
        this.currentLang = this.langData[1].name
      } else {
        this.currentLang = this.langData[0].name
      }
      // this.getCourseList(data.data.data.roomId)
    })
  },
  methods: {
    selectLang (index, lang) {
      this.currentLang = lang.name
      if (index === 0) {
        this.roomInfo.languageId = 10
      } else if (index === 1) {
        this.roomInfo.languageId = 35
      } else if (index === 2) {
        this.roomInfo.languageId = 4
      } else if (index === 3) {
        this.roomInfo.languageId = 11
      } else if (index === 4) {
        this.roomInfo.languageId = 29
      }
    },
    createRoom () {
      this.toggle = false
      console.log(this.langActive)
      if (this.langActive === -1) {
        this.toggle = true
        return false
      }
      this.updataLang()
    },
    joinRoom () {
      console.log(this.$store.state.courseId)
      this.updataLang()
    },
    prepareLession () {
      let roomId = this.roomInfo.roomId
      let languageId = this.roomInfo.languageId
      this.$router.push({name: 'Prepare', params: {roomId: roomId, languageId: languageId}})
    },
    updataLang () {
      let roomId = this.roomInfo.roomId
      let languageId = this.roomInfo.languageId
      console.log(this.roomInfo)
      let url = `${HYBIRD_URL}/programming/room/roomId/${roomId}/languageId/${languageId}/api?access_token=${this.accessToken}`
      ajaxAPI('PUT', url).then(data => {
        console.log(data)
        this.goWhereLang()
      })
    },
    goWhereLang () {
      let languageId = this.roomInfo.languageId || 10
      let roomId = this.roomInfo.roomId
      console.log(typeof languageId)  
      if (parseInt(languageId) === 35) {
        this.$router.push({name: 'WebTeacher', params: {roomId: roomId, languageId: languageId}})
      } else {
        this.$router.push({name: 'Anchor', params: {roomId: roomId, languageId: languageId}})
      }
    }
  }
}
</script>
 
<style lang="scss">
  .classroom{
    box-sizing: border-box;
    text-align: center;
    color:#8B9194;
    height:100%;
    display:-webkit-flex;
    display:-ms-flex;    
    display:flex;
    justify-content: space-around;
    padding-top:110px;
    

    .create-room{
      margin-top: 48px;
      p{
        font-size: 12px;
      }
    }

    .createRoom{
      width: 320px;
      height: 380px;
      background: #fff;
      position: relative;
      border-radius:5px;

      .c-title{
        height:39px;
        padding: 10px 30px;
        border-bottom: 1px solid #D1D3D4;
        line-height:39px;
        text-align: left;
        color:#22B8FF;
        font-size: 16px;
        font-weight: 400;
        span{
          letter-spacing: 8px
        }
      }
      .c-body{
        padding: 30px 30px 53px;
        text-align: left;

        .c-label{
          display: inline-block;
          color: #666666;
          font-size: 12px;
          margin-bottom: 6px;
        }
        .lan{
          padding-left: 20px;
          box-sizing: border-box;
          color: #22E6A8; 
          font-size: 14px;         
        }
        .chooseLan{
          position:relative;
          width: 260px;
          line-height: 30px;
          border: 1px solid #22E6A8;
          border-radius: 20px;
          background: url(../../assets/Triangle_green.png) no-repeat scroll 230px center transparent;
          background-size: 10px 6px;
          background-color:#fff;

          .drop-down{
            position: absolute;
            top: 40px;
            width: 230px;
            box-shadow: 0 0 4px 0 rgba(179, 229, 255, 100);
            background-color: #FFF;
            z-index: 99;
            
            a{
              display: block;
              color: #22E6A8;
              line-height: 28px;
              background-color: #fff;
            }
            li:hover a{
              border-left: 2px solid #22E6A8
            }
          }
          .drop-down:before{
            position: absolute;
            content:"";
            top:-10px;
            right:20px;
            width:10px;
            height:10px;
            transform-origin: bottom right;
            transform: rotate(-45deg);
            box-shadow: 1px -1px 4px -1px rgba(179, 229, 255, 100);
            background:#fff;
          }
          .drop-down li{
            border-bottom: 1px solid #D1D3D4;
            padding-top: 6px ;
            padding-bottom: 6px;
          }
        }
        .quickTool:before{
          position: absolute;
          content:"";
          top:-10px;
          left:-10px;
          right:-10px;
          bottom:-10px;
        }
      }
      .roomId{
        width: 260px;
        line-height: 56px;
        background:rgba(34, 184, 255, .1);
        color:#1FB6FF;
        font-size: 20px;
        font-weight: 400;
        text-align: center;
        letter-spacing: 20px;
        margin-bottom: 20px;
      }
      .c-btn{
        display: block;
        font-size:14px;
        width: 220px;
        margin: 0 auto;
        background: #1FB6FF;
        height: 34px;
        border-radius: 20px;
        border: 0;
        letter-spacing: 14px;
        color: #fff;
        font-weight: 300;
      }
      .p-btn{
        margin:15px auto;
        border:0;
        background: #fff;
        letter-spacing: 14px
      }
    }
    .courseList{
      width:320px;
      height:380px;

    }
  }
</style>



// WEBPACK FOOTER //
// classroom.vue?7190b3c6